'use strict';

import { scrollToElement } from 'theme-utilities';
import { DOM } from './init';

export const doAjaxFiltering = (args = {}) => {
	const wrapper = document.querySelector(DOM.section);
	const filteringClass = 'filtering';
	const replacingClass = 'replacing';
	const timeout = 250;

	const defaults = {};
	const formData = new FormData(document.querySelector(DOM.form));
	for (const [key, value] of formData.entries()) {
		defaults[key] = value;
	}

	const body = Object.assign(defaults, args);

	/**
	 * Before fetching
	 */

	// Activate filtering state
	wrapper.classList.add(filteringClass);

	// Scroll back to top of posts container
	scrollToElement('#latest-posts');

	/**
	 * Fetching
	 */
	fetch(`${wp_ajax.url}?action=postfilter`, {
		method: 'POST',
		body: JSON.stringify(body),
		headers: {
			'Content-Type': 'application/json',
		},
	})
		.then((res) => res.json())
		.then((response) => {
			const data = response.data;

			wrapper.classList.add(replacingClass);
			setTimeout(() => {
				document.querySelector(DOM.postsContainer).innerHTML = data.content;
				wrapper.classList.remove(replacingClass);
			}, timeout);

			/**
			 * Pagination
			 */
			if (response.success) {
				document.querySelectorAll(DOM.paginationWrapper).forEach((pagination) => {
					pagination.innerHTML = data.pagination;
				});

				// Trigger postsLoaded event type to reinitialize new pagination elements
				const event = new CustomEvent('postsLoaded', { detail: body.filter_page });
				document.dispatchEvent(event);
			} else {
				document.querySelectorAll(DOM.paginationWrapper).forEach((pagination) => {
					pagination.innerHTML = '';
				});
			}

			// Disable filtering state
			setTimeout(() => {
				wrapper.classList.remove(filteringClass);
			}, timeout);
		})
		.catch((error) => {
			console.error('Unfortunately, an error occurred while filtering the blog posts.', error);
		});
};
